import { selectFeatureFlags } from 'core/userContext';
import { Code } from 'modules/campaigns/editor/styles';
import { MessageMedium } from 'modules/domains/campaign';
import { useSelector } from 'react-redux';
import { useCampaignContext, useTemplateContext } from '../../../context';
import { EmailPrimaryContent } from '../../../types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';
import { LightText, SectionHeader, SectionWrapper } from '../Sections.styled';

export const LINKS_SECTION_TEST_ID = 'links-section';

export const LinksSection = () => {
  const { LinkShortening } = useSelector(selectFeatureFlags);
  const { templateAndContent } = useTemplateContext();
  const { isSMSLinkShorteningEnabled } = useTemplateContext();
  const primaryContent = templateAndContent?.primaryContent as EmailPrimaryContent;
  const { shortenLinks } = templateAndContent;

  const linkParams = primaryContent?.linkParams;
  const googleAnalyticsCampaignName = primaryContent?.googleAnalyticsCampaignName;

  const { campaign } = useCampaignContext();
  const { messageMedium } = campaign;

  return (
    <SectionWrapper data-test={LINKS_SECTION_TEST_ID}>
      <SectionHeader>Links</SectionHeader>

      {
        /** These fields are only available for SMS  */
        messageMedium === MessageMedium.SMS && (
          <CampaignFormField labelText="Shorten and track">
            <ReadOnlyField name="track">
              {isSMSLinkShorteningEnabled ? 'On' : <LightText>Off</LightText>}
            </ReadOnlyField>
          </CampaignFormField>
        )
      }

      <CampaignFormField labelText="Google analytics">
        <ReadOnlyField name="googleAnalyticsCampaignName">
          {googleAnalyticsCampaignName ? (
            <>
              On
              <Code>{googleAnalyticsCampaignName}</Code>
            </>
          ) : (
            <LightText>Off</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Link parameters">
        <ReadOnlyField name="linkParams">
          {linkParams?.length ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>

      {LinkShortening && (
        <CampaignFormField labelText="Link shortening">
          <ReadOnlyField name="linkShortening">
            {!!shortenLinks ? 'On' : <LightText>Off</LightText>}
          </ReadOnlyField>
        </CampaignFormField>
      )}
    </SectionWrapper>
  );
};
